// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"53":"dash","817":"hls"}[chunkId] || chunkId) + "." + {"53":"4c279377","377":"b48ed104","817":"44178f15"}[chunkId] + ".chunk.js";
};